<div
  class="main flex items-center"
  [ngClass]="{
    checked: checked$ | async,
    'stay-open': hasContextMenuOpen,
    'padding-right': hasPaddingRight
  }"
  (contextmenu)="onContextMenu($event, archivedTrack)"
  (click)="onSelectClickLine($event)"
>
  <figure>
    <img [src]="archivedTrack.cover" />
    <div class="button-overlay">
      <mat-checkbox (change)="selectLine()" [checked]="checked$ | async"></mat-checkbox>
    </div>
  </figure>

  <div class="title elipsis">
    <span class="elipsis"> {{ archivedTrack.title }} </span>
    <div class="title-buttons">
      <rk-icon-button
        [bordered]="true"
        [faIcon]="isLoaded && isPlaying ? 'fa-pause' : 'fa-play'"
        class="mr-1"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="playArchivedTrack(archivedTrack)"
      >
      </rk-icon-button>
      <rk-icon-button
        [bordered]="true"
        [svgIcon]="'dot-down'"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="onContextMenu($event, archivedTrack)"
      >
      </rk-icon-button>
    </div>
  </div>
  <div class="artist elipsis">{{ archivedTrack.artist }}</div>
  <div class="album elipsis" *ngIf="columns.album">{{ archivedTrack.album }}</div>
  <div class="year" *ngIf="columns.year">{{ archivedTrack.year }}</div>
  <div class="added" *ngIf="columns.addedDate">
    {{
      archivedTrack.archivedAt
        | fromNow : { amount: 30, unit: 'days', withoutPrefix: true }
    }}
  </div>
  <div class="duration" *ngIf="columns.duration">
    {{ archivedTrack.timeSeconds ? (archivedTrack.timeSeconds | timeFormat) : '' }}
  </div>
  <div class="bpm" *ngIf="columns.bpm">
    {{ archivedTrack.bpm }}
  </div>
  <div class="kbps" *ngIf="columns.kbps">
    {{ archivedTrack.bitrate }}
  </div>
</div>
